<script lang="ts" setup>
const props = defineProps({
  modelValue: { type: Boolean, required: true },
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  customClass: { type: String, default: '' },
  timeout: { type: Number, default: 0 },
})

const slots = useSlots()
const emit = defineEmits(['update:modelValue'])
const timeoutCloseSuccess = ref<NodeJS.Timeout | null>(null)

const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

watch(
  () => props.modelValue,
  (value) => {
    if (value && props.timeout) {
      timeoutCloseSuccess.value = setTimeout(
        () => (visible.value = false),
        props.timeout,
      )
    }
  },
)

onBeforeUnmount(() => {
  if (timeoutCloseSuccess.value) {
    clearTimeout(timeoutCloseSuccess.value)
  }
})

const { isMobile } = useDevice()
</script>

<template>
  <base-modal
    v-model="visible"
    class="base-instruction-modal"
    :class="customClass"
    :custom-class="isMobile ? 'base-instruction-modal-mobile' : ''"
  >
    <div class="base-instruction">
      <p v-if="title" class="base-instruction__title">{{ title }}</p>
      <div class="base-instruction__description">
        <template v-if="slots.description">
          <slot name="description" />
        </template>
        <template v-else>
          {{ description }}
        </template>
      </div>
    </div>
    <template #footer>
      <div v-if="slots.footer">
        <slot name="footer" />
      </div>
    </template>
  </base-modal>
</template>
